module.exports = __webpack_public_path__ + "static/img/banner-ngambis.b1cbcd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-ngambis.jpg
// module id = llUi
// module chunks = 1